import { IRoute, IRouteType } from "App/types";
import { LoginPage, RegisterPage, VerifyPage, ConfirmEmailPage } from "Auth/pages";
import { PATHS } from "App/router";

/* 
  Route object used to build the applications router.
  - `privateRoute` property is used to define a route that can only be accessed by authenticated users.
  - `authRoute` property is used to define a route that can only be accessed by NOT authenticated users
*/
export const authRoutes: IRoute[] = [
  {
    Component: RegisterPage,
    path: PATHS.REGISTER,
    exact: true,
    type: IRouteType.auth,
  },
  {
    Component: LoginPage,
    path: PATHS.LOGIN,
    exact: true,
    type: IRouteType.auth,
  },
  {
    Component: VerifyPage,
    path: PATHS.VERIFY,
    exact: true,
  },
  {
    Component: ConfirmEmailPage,
    path: PATHS.CONFIRM_EMAIL,
    exact: true,
    type: IRouteType.private,
  },
];
